module.exports = __webpack_public_path__ + "img/identity-camera.f2ca65ac.png";